<template>
  <aside class="sidebar" :class="{ collapsed: isCollapsed }">
    <!-- Logo -->
    <div class="logo" v-if="!isCollapsed">
      <div class="logo-icon">
        <img :src="logoImg" alt="Logo" />
      </div>
      <span>大象魔法AIGC</span>
    </div>
    <div class="logo-icon-only" v-else>
      <div class="logo-icon">
        <img :src="logoImg" alt="Logo" />
      </div>
    </div>

    <!-- 新建任务按钮
    <button class="new-task-btn" v-if="!isCollapsed" @click="handleNewTask">
      <i class="fa-solid fa-plus"></i>
      <span>新建任务</span>
    </button>
    <button class="new-task-btn-icon" v-else @click="handleNewTask" title="新建任务">
      <i class="fa-solid fa-plus"></i>
    </button>
-->
    <div class="menu-div-out">
      <div class="menu-div-in">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          :collapse="isCollapsed"
          @select="onMenuSelect"
        >
          <el-menu-item-group>
            <el-tooltip :disabled="!isCollapsed" content="内容生产工具" placement="right" effect="dark">
              <el-menu-item index="i_0" route="">
                <i class="fa-solid fa-pen-nib"></i>
                <span v-if="!isCollapsed" class="font">内容生产工具</span>
              </el-menu-item>
            </el-tooltip>

          </el-menu-item-group>

          <el-menu-item-group title="批量制作">
            <el-tooltip :disabled="!isCollapsed" content="项目管理" placement="right" effect="dark">
              <el-menu-item index="i_12" route="">
                <i class="fa-regular fa-chart-bar"></i>
                <span v-if="!isCollapsed" class="font">报告及视频制作</span>
              </el-menu-item>
            </el-tooltip>
            <el-tooltip :disabled="!isCollapsed" content="口播视频批量制作" placement="right" effect="dark">
              <el-menu-item index="i_17" route="">
                <i class="fa-solid fa-microphone-lines"></i>
                <span v-if="!isCollapsed" class="font">数字人视频</span>
              </el-menu-item>
            </el-tooltip>
            <el-tooltip :disabled="!isCollapsed" content="视频混剪快速版" placement="right" effect="dark">
              <el-menu-item index="i_18" route="">
                <i class="fa-solid fa-forward-fast"></i>
                <span v-if="!isCollapsed" class="font">视频混剪(快速版)</span>
              </el-menu-item>
            </el-tooltip>
            <el-tooltip :disabled="!isCollapsed" content="视频批量混剪" placement="right" effect="dark">
              <el-menu-item index="i_16" route="">
                <i class="fa-solid fa-film"></i>
                <span v-if="!isCollapsed" class="font">视频混剪(专业版)</span>
              </el-menu-item>
            </el-tooltip>

            

          </el-menu-item-group>

          <el-menu-item-group title="存储">
            <el-tooltip :disabled="!isCollapsed" content="云盘空间" placement="right" effect="dark">
              <el-menu-item index="i_5" route="">
                <i class="fa-solid fa-cloud"></i>
                <span v-if="!isCollapsed" class="font">云盘空间</span>
              </el-menu-item>
            </el-tooltip>
          </el-menu-item-group>
          <el-menu-item-group title="其他">
            <el-tooltip :disabled="!isCollapsed" content="后台进程" placement="right" effect="dark">
              <el-menu-item index="i_10" route="">
                <i class="fa-solid fa-server"></i>
                <span v-if="!isCollapsed" class="font">后台进程</span>
                <el-tag v-if="!isCollapsed && taskCount>0" type="warning" size="small" round effect="dark" style="margin-left: 6px;">{{ taskCount }}</el-tag>
              </el-menu-item>
            </el-tooltip>

            <el-tooltip :disabled="!isCollapsed" content="个人中心" placement="right" effect="dark">
              <el-menu-item index="i_7" route="">
                <i class="fa-regular fa-user"></i>
                <span v-if="!isCollapsed" class="font">个人中心</span>
              </el-menu-item>
            </el-tooltip>

            <el-tooltip v-if="showAgentCenter" :disabled="!isCollapsed" content="代理中心" placement="right" effect="dark">
              <el-menu-item index="i_11" route="">
                <i class="fa-solid fa-shield-halved"></i>
                <span v-if="!isCollapsed" class="font">代理中心</span>
              </el-menu-item>
            </el-tooltip>
          </el-menu-item-group>
        </el-menu>

        <div class="footer" :class="{ collapsed: isCollapsed }">
          <!--<el-text type="info" size="small">© 深圳科赛力量科技有限公司</el-text>-->
          <div v-if="!isCollapsed" class="footer-links">
            <el-link type="info" @click="openServiceTerms" underline="never" class="footer-link">
              <el-text type="info" size="small">服务条款</el-text>
            </el-link>
            <el-link type="info" @click="openPrivacyPolicy" underline="never" class="footer-link">
              <el-text type="info" size="small">隐私政策</el-text>
            </el-link>
          </div>

        </div>
      </div>
    </div>
    <div class="collapse-btn">
      <button class="collapse-btn-inner" @click="$emit('toggleCollapse')">
        <i :class="isCollapsed ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"></i>
      </button>
    </div>
  </aside>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'
import { Picture, User, Coin, Files, Document, Mic, Film, Present, Share, Grid, FolderOpened, Fold, Odometer, Message, Plus, Expand } from '@element-plus/icons-vue'
import { getAiToolsTasksList } from '@/api/portal/aitools'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import logoImg from '@/apps/portal/assets/logo.jpg'
import { useUserStore } from '@/stores/portal/user'

const emit = defineEmits(['toggleCollapse', 'menuSelect', 'titleChange'])
const router = useRouter()
const userStore = useUserStore()

const props = defineProps({
  isCollapsed: {
    type: Boolean,
    default: false
  },
  activeMenu: {
    type: String,
    default: 'i_0'
  }
})

// 任务数量
const taskCount = ref(0)
let taskCountInterval = null

// 登录状态检查
const isLoggedIn = computed(() => {
  return !!userStore.token || !!localStorage.getItem('token')
})

// 是否显示代理中心：从用户信息中读取 agentStatus，当等于 1 时显示
const showAgentCenter = computed(() => {
  try {
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr)
      return userInfo && userInfo.agentStatus === 1
    }
  } catch (e) {
    console.error('解析用户信息失败:', e)
  }
  return false
})

// 菜单配置：定义哪些菜单需要登录验证和标题
const menuConfig = {
  'i_0': { requiresAuth: false, name: '全部', title: 'AI 任务控制台' },           // 全部工具 - 不需要登录
  'i_5': { requiresAuth: true, name: '云盘空间', title: '云盘空间' },        // 云盘空间 - 需要登录
  'i_7': { requiresAuth: true, name: '个人中心', title: '个人中心' },        // 个人中心 - 需要登录
  'i_8': { requiresAuth: true, name: '邀请有礼', title: '邀请有礼' },        // 邀请有礼 - 需要登录
  'i_10': { requiresAuth: true, name: '后台进程', title: '后台进程' },        // 后台进程 - 需要登录
  'i_11': { requiresAuth: true, name: '代理中心', title: '代理中心' },        // 代理中心 - 需要登录
  'i_12': { requiresAuth: false, name: '视频项目', title: '视频项目' },       // 浏览无需登录，创建时再校验
  'i_13': { requiresAuth: true, name: '我的任务', title: '我的任务' },        // 我的任务 - 需要登录
  'i_16': { requiresAuth: true, name: '视频批量混剪', title: '视频批量混剪' },
  'i_17': { requiresAuth: true, name: '口播视频批量制作', title: '口播视频批量制作' },
  'i_18': { requiresAuth: true, name: '视频混剪快速版', title: '视频混剪(快速版)' }
}

// 菜单点击处理
const onMenuSelect = (menuIndex) => {
  const menu = menuConfig[menuIndex]

  if (!menu) {
    console.warn(`未找到菜单配置: ${menuIndex}`)
    return
  }

  // 检查是否需要登录验证
  if (menu.requiresAuth && !isLoggedIn.value) {
    ElMessage.warning(`请先登录后再使用${menu.name}功能`)
    router.push('/login')
    return
  }

  // 通过验证，正常触发菜单选择事件
  emit('menuSelect', menuIndex)
  // 发送标题变化事件
  if (menu.title) {
    emit('titleChange', menu.title)
  }
}

// 新建任务处理
const handleNewTask = () => {
  // 可以在这里添加新建任务的逻辑
  ElMessage.info('新建任务功能')
}

// 获取基础路径，兼容测试和正式环境
const getBasePath = () => {
  const base = import.meta.env.VITE_APP_BASE_URL || '/'
  // 移除末尾的斜杠（如果有），因为路径已经以 / 开头
  return base.endsWith('/') ? base.slice(0, -1) : base
}

const openServiceTerms = () => {
  const basePath = getBasePath()
  window.open(`${basePath}/terms`, '_blank')
}

const openPrivacyPolicy = () => {
  const basePath = getBasePath()
  window.open(`${basePath}/privacy`, '_blank')
}

// 获取任务数量
const fetchTaskCount = async () => {
  // 检查登录状态，未登录时不获取任务数量
  if (!isLoggedIn.value) {
    taskCount.value = 0
    return
  }

  try {
    const res = await getAiToolsTasksList()

    // 添加更详细的数据验证
    if (res && res.code === 0) {
      let taskList = [];
      // 检查不同的数据结构
      if (res.data && Array.isArray(res.data)) {
        taskList = res.data;
      } else if (res.list && Array.isArray(res.list)) {
        taskList = res.list;
      } else if (res.page && res.page.list && Array.isArray(res.page.list)) {
        taskList = res.page.list;
      } else {
        // 如果没有找到数组数据，设置为0
        taskCount.value = 0
        console.warn('API响应中没有找到任务列表数据:', res)
      }
      // 只计算status为0或1的任务数量
      taskCount.value = taskList.filter(task =>
        task && (task.status === 0 || task.status === 1)
      ).length;
    } else {
      // API返回错误状态
      taskCount.value = 0
      console.warn('API返回错误状态:', res)
    }
  } catch (e) {
    // 错误处理
    console.error('获取任务数量失败:', e)
    taskCount.value = 0

    // 如果是网络错误，可以尝试重新获取
    if (e.message && e.message.includes('Network Error')) {
      console.log('网络错误，将在下次定时器时重试')
    }
  }
}

// 监听登录状态变化，自动获取任务数量
watch(isLoggedIn, (newValue) => {
  if (newValue) {
    // 用户登录后，立即获取任务数量
    fetchTaskCount()
  } else {
    // 用户退出登录后，清空任务数量
    taskCount.value = 0
  }
})

// 监听 activeMenu 变化，更新标题
watch(() => props.activeMenu, (newMenu) => {
  const menu = menuConfig[newMenu]
  if (menu && menu.title) {
    emit('titleChange', menu.title)
  }
}, { immediate: true })

onMounted(() => {
  // 只在已登录状态下获取任务数量
  if (isLoggedIn.value) {
    fetchTaskCount()
    // 每30秒刷新一次任务数量
    taskCountInterval = setInterval(fetchTaskCount, 30000)
  }
})

onBeforeUnmount(() => {
  if (taskCountInterval) {
    clearInterval(taskCountInterval)
    taskCountInterval = null
  }
})
</script>

<style scoped>
.sidebar {
  width: 270px;
  background: var(--bg-panel);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  padding: 24px 18px;
  flex-shrink: 0;
  box-shadow: var(--shadow-float);
  z-index: 10;
  transition: width 0.3s ease;
  position: relative;
  height: 100%;
  box-sizing: border-box;
}

.sidebar.collapsed {
  width: 80px;
  padding: 24px 12px;
}

/* Logo */
.logo {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 28px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon-only {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
  padding: 0;
}

.logo-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.logo-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

/* 新建任务按钮 */
.new-task-btn {
  background: var(--gradient-brand);
  color: #fff;
  border: none;
  padding: 14px;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  width: 100%;
}

.new-task-btn:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 16px rgba(79, 70, 229, 0.4);
}

.new-task-btn-icon {
  background: var(--gradient-brand);
  color: #fff;
  border: none;
  padding: 14px 0;
  border-radius: var(--radius-md);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  width: 100%;
  min-height: auto;
}

.new-task-btn-icon:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(79, 70, 229, 0.4);
}

.new-task-btn-icon i {
  font-size: 16px;
}

.font {
  font-size: 14px;
}

.menu-div-out {
  flex: 1;
  position: relative;
  overflow: hidden;
  min-height: 0;
}

.menu-div-in {
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  padding-right: 4px;
}

.menu-div-in::-webkit-scrollbar {
  width: 0;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: auto;
  padding-left: 8px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid var(--border-light);
  gap: 8px;
}

.footer .el-text,
.footer .el-link {
  text-align: left !important;
  align-self: flex-start;
}

.footer-links {
  display: flex;
  gap: 16px;
  align-items: center;
}

.footer-link {
  cursor: pointer;
  transition: color 0.2s;
}

.footer-link:hover {
  color: var(--text-brand, #4F46E5) !important;
}

.footer.collapsed {
  display: none;
}

.collapse-btn {
  position: absolute;
  top: 50%;
  right: -12px;
  transform: translateY(-50%);
  z-index: 60;
}

.collapse-btn-inner {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #E5E7EB;
  background: white;
  color: var(--text-secondary);
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-size: 12px;
}

.collapse-btn-inner:hover {
  color: var(--accent-blue);
  border-color: var(--accent-blue);
}

.el-menu-vertical-demo {
  border-right: none;
  background: transparent;
}

/* Element Plus 菜单样式覆盖 */
:deep(.el-menu-item-group__title) {
  font-size: 12px;
  font-weight: 700;
  color: #9CA3AF;
  margin-bottom: 10px;
  padding-left: 12px;
  letter-spacing: 0.5px;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 1.5;
}

/* 折叠时隐藏分组标题 */
.sidebar.collapsed :deep(.el-menu-item-group__title) {
  display: none;
}

/* 折叠时在分组之间添加分割线 */
.sidebar.collapsed :deep(.el-menu-item-group) {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.sidebar.collapsed :deep(.el-menu-item-group:last-child) {
  border-bottom: none;
  margin-bottom: 0;
}

:deep(.el-menu-item) {
  padding: 10px 12px;
  color: var(--text-secondary);
  border-radius: 12px;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s;
  margin-bottom: 4px;
  height: auto;
  line-height: 1.5;
}

:deep(.el-menu-item .font) {
  margin-left: 10px;
}

:deep(.el-menu-item:hover) {
  background: white;
  color: var(--text-brand);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
}

:deep(.el-menu-item.is-active) {
  background: white;
  color: var(--text-brand);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
}

:deep(.el-menu-item .el-icon),
:deep(.el-menu-item i) {
  width: 24px;
  font-size: 16px;
  color: #9CA3AF;
  transition: color 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

:deep(.el-menu-item:hover .el-icon),
:deep(.el-menu-item.is-active .el-icon),
:deep(.el-menu-item:hover i),
:deep(.el-menu-item.is-active i) {
  color: var(--text-brand);
}

:deep(.el-menu--collapse .el-menu-item) {
  padding: 10px;
  justify-content: center !important;
  display: flex !important;
  align-items: center !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-menu-item__content) {
  justify-content: center !important;
  display: flex !important;
  align-items: center !important;
  width: 100%;
  margin: 0 auto !important;
  padding: 0 !important;
}

:deep(.el-menu--collapse .el-menu-item i) {
  margin: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 24px;
  flex-shrink: 0;
  position: relative;
  left: -4px; /* 强制往左偏移一点，确保居中 */
  right: 0;
}

:deep(.el-menu--collapse .el-menu-item .font) {
  display: none;
}

/* Tooltip 样式优化 */
:deep(.el-tooltip__trigger) {
  width: 100%;
  display: block;
}

/* 折叠状态下 tooltip 触发区域 */
.sidebar.collapsed :deep(.el-tooltip) {
  width: 100%;
}
</style>
